import { render, staticRenderFns } from "./RegisterDataPribadi.vue?vue&type=template&id=09fb2488&scoped=true&"
import script from "./RegisterDataPribadi.vue?vue&type=script&lang=js&"
export * from "./RegisterDataPribadi.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDataPribadi.vue?vue&type=style&index=0&id=09fb2488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb2488",
  null
  
)

export default component.exports